import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import type { User } from "../../types"
import UtenteForm from "./UtenteForm"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesUtente, validationSchemaUtente } from "./UtenteCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useDeleteUtente, useUpdateUtente, useUtente } from "../../hooks/utenti"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"

export default function UtenteUpdate() {
  const updateUtente = useUpdateUtente()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: utente } = useUtente(Number(id))

  const deleteUtente = useDeleteUtente()

  const [modalStateDeleteUtente, modalActionsDeleteUtente] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesUtente(utente), [utente])
  const validationSchema = useMemo(() => validationSchemaUtente(), [])

  useBreadcrumbs([{ label: "Utenti", href: "/utenti/utenti" }, { label: "Dettaglio Utente" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{utente?.full_name}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteUtente.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return updateUtente.mutateAsync(values as User).then(() => {
                navigate(`/utenti/utenti`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <UtenteForm />
                </Container>
                <BottomFormFixed url="/utenti/utenti" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteUtente.isOpen}
        onClose={modalActionsDeleteUtente.close}
        onDelete={() => {
          return deleteUtente.mutateAsync(utente?.id).then(() => {
            navigate(`/utenti/utenti`)
          })
        }}
        message="Sei sicuro di voler eliminare l'utente"
        title="Elimina Utente"
      />
    </Layout>
  )
}
